<template>
  <svg fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m8.795 15.875-4.17-4.17-1.42 1.41 5.59 5.59 12-12-1.41-1.41-10.59 10.58Z"
    />
  </svg>
</template>
